var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 34,
    viewBox: "0 0 46 34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "#334368",
    fillRule: "evenodd",
    stroke: "none",
    d: "M 14.892578 15.143677 C 15.779175 15.826111 15.789429 15.788269 16.373535 16.559265 C 16.928589 17.29126 19.297852 18.998657 19.606445 19.510803 C 20.318237 20.369751 22.373413 20.668579 23.688721 20.25238 C 25.565796 19.658447 27.801392 16.932556 29.609009 15.252441 C 32.575684 12.495605 36.533936 8.786804 39.305908 5.957092 L 42.093262 3.285889 C 42.481323 2.918823 43.199341 2.342407 43.458252 1.974731 L 1.204712 1.952087 C 1.785522 2.850586 7.081177 7.526123 8.03479 8.518799 C 8.677856 9.187744 9.067993 9.565186 9.713257 10.139771 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "#334368",
    fillRule: "evenodd",
    stroke: "none",
    d: "M 18.949951 20.940979 L 18.786987 20.855164 C 18.655151 20.743591 18.583862 20.672546 18.489136 20.583374 L 18.355469 20.489258 L 18.207153 20.410339 C 18.015991 20.450928 18.077393 20.479126 18.077393 20.264282 L 15.968018 18.27655 L 8.548706 25.352661 C 7.565552 26.409607 4.315796 29.303589 2.933472 30.653809 L 1.202393 32.425781 L 43.439575 32.426392 C 43.242188 31.905273 35.504639 24.648132 34.239624 23.484192 L 28.704346 18.276184 C 26.552734 20.05957 23.84375 23.895264 18.949951 20.940979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    fill: "#334368",
    fillRule: "evenodd",
    stroke: "none",
    d: "M 0.001587 31.320923 C 0.443359 31.133728 3.276245 28.372437 3.75061 27.83197 L 11.114746 20.750366 C 11.757202 20.152039 12.408691 19.616882 13.009399 19.005981 L 14.821045 17.19043 L 9.333618 11.883179 C 8.647339 11.249817 8.177368 10.802002 7.480469 10.100769 C 6.289795 8.903381 5.070313 7.826782 3.808105 6.612488 C 3.138184 5.967224 2.64624 5.565125 1.955444 4.826294 C 1.425293 4.258911 0.631836 3.340698 0.015137 3.057556 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    fill: "#334368",
    fillRule: "evenodd",
    stroke: "none",
    d: "M 29.845337 17.19043 L 37.189941 24.285034 C 39.096802 25.995178 40.890991 27.870422 42.712158 29.565796 C 43.063965 29.892944 44.298462 31.155762 44.648193 31.311401 L 44.662354 3.043579 C 44.229248 3.235229 43.358276 4.216125 42.770142 4.759277 C 42.09668 5.381226 41.568237 5.949707 40.924194 6.551025 C 39.643188 7.745605 38.448242 8.917542 37.183228 10.09021 C 35.954224 11.229492 34.784424 12.499512 33.553223 13.621948 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGift);
export default __webpack_public_path__ + "static/media/icon-gift.b0ad7a56f4c1ab4a304d14ad61860f42.svg";
export { ForwardRef as ReactComponent };